import { FormattedMessage, useIntl } from "react-intl";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";

import { useTranslationsContext } from "../../../../contexts/useTranslationsContext";
import { GUIDES_LIST, GUIDES_LIST_ZH } from "../../../../helpers/constants";

import EmptyState from "../../../components/common/EmptyState/EmptyState";
import Search from "../../../components/common/Search/Search";

import "./Guides.css";

const Guides = () => {
	const [filteredGuides, setFilteredGuides] = useState(GUIDES_LIST);
	const [search, setSearch] = useState<string>("");
	const [searchParams, setSearchParams] = useSearchParams();

	const intl = useIntl();

	const { userLocale } = useTranslationsContext();

	useEffect(() => {
		const searchParam = searchParams.get("search");

		if (searchParam) {
			setSearch(searchParam);
			setSearchParams((prev) => {
				prev.delete("search");

				return prev;
			});
		}
	}, [searchParams, setSearchParams]);

	useEffect(() => {
		if (search) {
			const guidesList =
				userLocale === "zh" ? GUIDES_LIST_ZH : GUIDES_LIST;

			const filtered = guidesList.filter((guide) =>
				guide.search.toLowerCase().includes(search.toLowerCase())
			);
			setFilteredGuides(filtered);
		} else {
			const guidesList =
				userLocale === "zh" ? GUIDES_LIST_ZH : GUIDES_LIST;

			setFilteredGuides(guidesList);
		}
	}, [search, userLocale, intl]);

	return (
		<div className="guides__content-wrapper">
			<div className="guides__header">
				<Search
					search={search}
					handleSearchFilter={() => {}}
					handleSearch={(value) => setSearch(value)}
					onKeyDownSearch={() => {}}
					handlePage={() => {}}
				/>
			</div>
			<div className="guides__content">
				<div className="guides__page-filters">
					<h5 className="guides__page-title">
						<FormattedMessage id="usageGuides" />
					</h5>
				</div>
				{filteredGuides.length > 0 ? (
					<div className="guides__list">
						{filteredGuides.map((guide) => (
							<div className="guides__guide-item">
								<h5 className="guides__guide-item-title">
									<FormattedMessage id={guide.title} />
								</h5>
								<iframe
									loading="lazy"
									src={guide.frame}
									width="100%"
									height={500}
									allowFullScreen
									title={guide.title}
								></iframe>
							</div>
						))}
					</div>
				) : (
					<EmptyState message="noGuidesFound" />
				)}
			</div>
		</div>
	);
};

export default Guides;
